// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox_wrapper__BSSK9"};